import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';

//routes
import Main from './components/Main'
import NotFound from './components/NotFound'
import ResumeSingle from './components/ResumeSingle'
import ResumeSingleExpanded from './components/ResumeSingleExpanded'

import injectTapEventPlugin from 'react-tap-event-plugin';
// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

class App extends Component {
  constructor(props){
    super(props);
    this.state={
      mainTitle:"John S. Ma",
    }
  }


  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/"
            render={(props) =>
              <Main
                appState={this.state}
                {...props}
              />
            }
          />
          <Route exact path="/resume"
            render={(props) =>
              <ResumeSingle
                appState={this.state}
              />
            }
          />
          <Route exact path="/resumeexpanded"
            render={(props) =>
              <ResumeSingleExpanded
                appState={this.state}
              />
            }
          />
          <Route path='*' component={NotFound} />
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js